/**
 * Product card hover/swipe for collection grid.
 * Desktop: CSS handles hover via .product-card--has-hover:hover rules in theme.css.
 * Mobile: swipe left/right to toggle between primary and hover images.
 * Delegates all events to .collection-grid container for efficiency.
 */
(function () {
  'use strict';

  var SWIPE_THRESHOLD = 50;
  var MAX_VERTICAL = 30;

  function initMobileSwipe() {
    var grids = document.querySelectorAll('.collection-grid');

    grids.forEach(function (grid) {
      var touchStartX = 0;
      var touchStartY = 0;
      var activeCard = null;

      grid.addEventListener('touchstart', function (e) {
        var card = e.target.closest('.product-card--has-hover');
        if (!card) return;
        activeCard = card;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }, { passive: true });

      grid.addEventListener('touchend', function (e) {
        if (!activeCard) return;

        var dx = e.changedTouches[0].clientX - touchStartX;
        var dy = Math.abs(e.changedTouches[0].clientY - touchStartY);

        /* Only register horizontal swipes */
        if (Math.abs(dx) > SWIPE_THRESHOLD && dy < MAX_VERTICAL) {
          var primary = activeCard.querySelector('.product-card__image--primary');
          var hover = activeCard.querySelector('.product-card__image--hover');
          if (!primary || !hover) { activeCard = null; return; }

          if (dx < 0) {
            /* Swipe left: show hover image */
            primary.style.opacity = '0';
            hover.style.opacity = '1';
            if (typeof debug !== 'undefined') debug.trace('collectionHover:swipe', { direction: 'left', product: activeCard.querySelector('.product-card__link')?.getAttribute('aria-label') });
          } else {
            /* Swipe right: show primary image */
            primary.style.opacity = '1';
            hover.style.opacity = '0';
            if (typeof debug !== 'undefined') debug.trace('collectionHover:swipe', { direction: 'right', product: activeCard.querySelector('.product-card__link')?.getAttribute('aria-label') });
          }
        }

        activeCard = null;
      }, { passive: true });
    });

    if (typeof debug !== 'undefined') debug.trace('collectionHover:init', { mode: 'mobile-swipe', gridCount: grids.length });
  }

  /* Only bind mobile swipe - desktop hover is pure CSS */
  if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMobileSwipe);
    } else {
      initMobileSwipe();
    }
  } else {
    if (typeof debug !== 'undefined') debug.trace('collectionHover:init', { mode: 'desktop-css-only' });
  }
})();
